import { CONTACT_FALLBACK_EMAIL } from '../../lib/contact'

/**
 * The chrome the assessment tools share, in Turkish — written 2026-08-31 with
 * the Guts Check and the ARI, because a Turkish tool inside an English "Question
 * 3 / 12" frame reads worse than either language on its own.
 *
 * It is shared, so translating it also puts the Diagnostic and the ROI
 * Calculator's gate into Turkish, which is what those two already wanted.
 *
 * `{n}`, `{total}`, `{max}`, `{avg}` are substituted at render and Turkish puts
 * them in different places than English does — `scoreLine` in particular reads
 * "{max} üzerinden {total}", not "{total} of {max}".
 */
export const toolsUiTr = {
  ui: {
    introNote:
      'Hazırlık da araştırma da gerekmiyor. Kimse izlemiyorken üst ekibiniz nasıl cevap verirdiyse öyle cevaplayın. Değer puanda değil, dürüstlükte.',
    start: 'Başla',
    questionCount: '{n} soru · yaklaşık dört dakika',
    question: 'Soru',
    back: 'Geri',
    next: 'İleri',
    seeVerdict: 'Sonucu gör',
    needAnswer: 'Devam etmek için bir seçenek işaretleyin.',
    needAnswerLast: 'Sonucunuzu görmek için bir seçenek işaretleyin.',
    level: 'Seviye',
    youAreHere: 'buradasınız',
    scoreLine: 'Puan: {max} üzerinden {total} · ortalama: 3.0 üzerinden {avg}',
    provocation: 'Bir sonraki yönetim toplantınıza götüreceğiniz soru',
    moves: 'Önce ne yapmalı',
    restart: 'Baştan başla',
    resumeNote:
      'Bunların bir kısmını daha önce bu cihazda cevaplamıştınız. Cevaplarınız hâlâ burada — bize hiçbir şey gönderilmedi.',
    resume: 'Kaldığınız yerden devam edin',
    ctaHeading: 'Bunu tahminlerle değil, kendi rakamlarınızla sınamak ister misiniz?',
    ctaLabel: 'Görüşme planlayın',
    notSaved:
      'Size bir kopyasını gönderebilmek için kaydedemedik; saklamak isterseniz ekran görüntüsü alın. Aşağıdaki sonucunuz her hâlükârda doğru.',
  },

  gate: {
    heading: 'Nereye gönderelim?',
    sub: 'Sonucunuz hazır. Bir kopyasını e-posta ile göndereceğiz; işinize yarayacaksa yanına sizin seviyenizdeki kurumların genelde sonra ne yaptığını anlatan bir sayfa ekleyeceğiz.',
    name: 'Adınız',
    namePlaceholder: 'Ada Lovelace',
    email: 'Kurumsal e-posta',
    emailPlaceholder: 'siz@sirket.com',
    company: 'Şirket',
    companyPlaceholder: 'Şirket adı',
    consent:
      'Sonucumu ve Digitopia’dan ara ara ilgili içerikleri bana gönderin. İstediğim zaman çıkabilirim.',
    submit: 'Sonucu göster',
    sending: 'Kaydediliyor…',
    privacy:
      'Bunu sonucunuzu göndermek ve bir kez geri dönmek için kullanıyoruz. Satmıyor, paylaşmıyoruz.',
    missing: {
      heading: 'Sonucunuzu gösterebilmemiz için bir şey kaldı:',
      name: 'Lütfen adınızı yazın.',
      email: 'Sonucunuzu gönderebilmemiz için geçerli bir kurumsal e-posta yazın.',
      company: 'Lütfen şirketinizin adını yazın.',
      consent: 'Sonucu e-posta ile gönderebilmemiz için onay kutusunu işaretleyin.',
      challenge: 'Lütfen butonun üstündeki güvenlik kontrolünü tamamlayın.',
    },
    challengeFailed: `Güvenlik doğrulaması tarayıcınızda yüklenmedi. Sayfayı yenileyin ya da bu sitede reklam engelleyiciyi kapatın — veya bize ${CONTACT_FALLBACK_EMAIL} adresinden yazın.`,
  },
}
